module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-6cf5a1333daef973b481bb0dd2ffc52f.png";